// extracted by mini-css-extract-plugin
export var Action = "Blankslate-module--Action--NNkZN";
export var Blankslate = "Blankslate-module--Blankslate--DLSpD";
export var Container = "Blankslate-module--Container--X3mFs";
export var Description = "Blankslate-module--Description--+AugM";
export var Heading = "Blankslate-module--Heading--gQORs";
export var Visual = "Blankslate-module--Visual--OUZ8G";